// Importaciones React generales
import React, { useState, useEffect, useRef } from 'react';
import secureLocalStorage from "react-secure-storage";
import { Route, Routes, NavLink, HashRouter } from "react-router-dom";


import logo from './vinoteca.png';

// Importaciones FontAwesomeIcon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/pro-solid-svg-icons";

// Importaciones Amplify
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplify_outputs.json';

import AWS from 'aws-sdk'

// Importaciones Estilos
import './Main.css';

// Importaciones Devexpress
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";

// import { licenseKey } from './devextreme-license.ts';
// import config from "devextreme/core/config";
import LicenseCheckComponent from './LicenseCheckComponent.js';

//Importaciones para el menu
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// Modulos del Kiosco
import Home from "./Home/Home";
import Invoice from "./Invoice/Invoice";

import { get } from 'aws-amplify/api';

// LoadPanel
import { LoadPanel } from 'devextreme-react/load-panel';

import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';

Amplify.configure(amplifyconfig);

// Gen2: las REST APIs migradas quedan bajo custom.API como 'kioscoAPI-<env>'.
// El cliente API (get/post) lee de API.REST, asi que las registramos ahi con el
// nombre base ('kioscoAPI') que usa el codigo.
const customApis = amplifyconfig?.custom?.API ?? {};
const restEndpoints = {};
for (const [key, cfg] of Object.entries(customApis)) {
  const baseName = key.replace(/-[^-]+$/, ''); // 'kioscoAPI-sandbox' -> 'kioscoAPI'
  restEndpoints[baseName] = { endpoint: cfg.endpoint, region: cfg.region };
}
if (Object.keys(restEndpoints).length > 0) {
  const existingConfig = Amplify.getConfig();
  Amplify.configure({
    ...existingConfig,
    API: {
      ...existingConfig.API,
      REST: { ...existingConfig.API?.REST, ...restEndpoints },
    },
  });
}

AWS.config.correctClockSkew = true;

export default function Main(props) {
  const [styles, setStyles] = useState({});

  // MENU HOME
  const [anchorHome, setAnchorHome] = React.useState(null);
  const openHome = Boolean(anchorHome);

  const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

  function handleClickHome(event) {
    setAnchorHome(event.currentTarget);
  };

  function handleCloseHome() {
    setAnchorHome(null);
  };

  const getStyles = React.useCallback(async () => {
    setVisibleLoadPanel(true);

    try {
      const apiName = 'kioscoAPI';
      const path = '/styles';

      const myInit = {
        headers: {
          'Content-Type': 'application/json'
        },
        queryStringParameters: {}
      };

      const response = await get({
        apiName,
        path,
        options: myInit
      }).response;

      var stylesGet = await response.body.json();

      setStyles(stylesGet);
    }
    catch (error) {
      console.error('Error fetching styles:', error);
    }
    finally {
      setVisibleLoadPanel(false);
    }
  }, []);

  useEffect(() => {
    async function initialize() {
      await getStyles();
    }

    initialize();

    loadMessages(esMessages);

    locale('es-MX');
  }, [getStyles]);

  return (
    <div>
      <LicenseCheckComponent />
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={visibleLoadPanel}
        showIndicator={true}
        message="Por favor espere..."
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
      />
      <HashRouter>
        <div>
          <table className="w-full bg-white" >
            <tbody>
              <tr>
                <th className="pl-3 w-1/6 pt-2 pb-2"><img src={logo} title="Vinoteca" alt="Vinoteca" width="280" /></th>
                <th className="w-1/5">
                </th>
              </tr>
            </tbody>
          </table>
          <React.Fragment>
            <Box sx={{ display: '-webkit-box', overflow: 'auto', alignItems: 'center', textAlign: 'center', backgroundColor: styles.custrecord_al_kiosco_cfg_color_menu }}>
              {/* *******MENU HOME******* */}
              <NavLink to="/" end>
                <Button
                  id="buttonHome"
                  aria-controls={openHome ? 'basic-menu' : undefined}
                  aria-haspopup="false"
                  aria-expanded={openHome ? 'true' : undefined}
                  onClick={handleClickHome}
                  style={{ fontSize: '17px', color: '#FFF', backgroundColor: styles.custrecord_al_kiosco_cfg_color_menu, margin: '0', borderRadius: 0 }}
                >
                  <FontAwesomeIcon icon={faHome} size="lg" />
                </Button>
              </NavLink>
            </Box>
          </React.Fragment>
          <div className="content">
            <Routes>
              <Route path="/" element={<Home />} />

              <Route path="/Invoice" element={<Invoice />} />
            </Routes>
          </div>
        </div>
      </HashRouter>
    </div>
  );
}